module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-word-e0d2ec8d.svg";